import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { AuthService } from './AuthService';
import { User } from 'oidc-client';
import { Permissions } from '../shared/models/permissions.enum';

const RequireAuth = <P extends object>(Component: React.ComponentType<P>, requiredPermissions?: Permissions[]) => {
  return class App extends React.Component<P & RouteComponentProps> {
    state = {
      isAuthenticated: false,
      isLoading: true,
      hasPermission: false
    };

    componentDidMount() {
      AuthService.getUser()
        .then(this.getUserHandle)
        .catch(() => {
          this.setState({ isLoading: false });
        });
    }

    getUserHandle: (user: User | null) => void = user => {
      const isAuthenticated = user && user.expires_at > Date.now() / 1000;
      const permissions = requiredPermissions ? requiredPermissions.map(x => x.toString()) : [];
      const requeredPermissions =
        permissions.length > 0 ? permissions : [Permissions.StitchingTool_Admin.toString(), Permissions.StitchingTool_General.toString()];
      const hasPermission = user && user.profile && requeredPermissions.some(x => [...user.profile.permission].indexOf(x) !== -1);
      this.setState({
        isAuthenticated: isAuthenticated,
        isLoading: false,
        hasPermission: hasPermission
      });
    };

    render() {
      const { isAuthenticated, isLoading, hasPermission } = this.state;
      const { match, location } = this.props;

      if (isLoading) {
        return <div>Loading...</div>;
      }

      if (!isAuthenticated) {
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location.pathname }
            }}
          />
        );
      }

      if (!hasPermission) {
        return <Redirect to={{ pathname: '/not-authorized', state: { from: match.url } }} />;
      }
      return <Component {...this.props} />;
    }
  };
};

export { RequireAuth };
